import { Box, Typography, IconButton, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const StepCard = styled(Box)({
  border: `1px solid ${colors.border.light}`,
  borderRadius: "12px",
  padding: "24px",
  background: colors.background.default,
});

export const StepHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "24px",
});

export const StepTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
});

export const StepTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.link,
  fontFamily: "Sora",
});

export const StepActions = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const ActionButton = styled(IconButton)({
  padding: "8px",
  "&:hover": {
    backgroundColor: colors.background.default,
  },
});

export const DragHandle = styled(Box)({
  cursor: "grab",
  display: "flex",
  alignItems: "center",
  padding: "8px",
  "&:active": {
    cursor: "grabbing",
  },
});

export const StepContent = styled(Box)({
  display: "flex",
  gap: "24px",
});

export const LeftColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  width: "50%",
});

export const RightColumn = styled(Box)({
  width: "50%",
});

export const FieldRow = styled(Box)({
  display: "flex",
  gap: "12px",
});

export const FieldHalf = styled(Box)({
  flex: 1,
});

